// Generated by CoffeeScript 2.4.1
(function() {
  var POST, Weaver, WeaverObject, WeaverSequence, enc;

  Weaver = require('./Weaver');

  WeaverObject = require('./WeaverObject');

  POST = Weaver.POST;

  enc = encodeURIComponent;

  WeaverSequence = class WeaverSequence extends WeaverObject {
    constructor(sequenceId) {
      var regCheck;
      super(sequenceId);
      regCheck = /^[0-9a-z]{3,30}$/;
      if ((sequenceId == null) || !regCheck.test(sequenceId)) {
        throw new Error('A sequence id should be passed containing only lowercase letters a-z, numbers 0-9 and have a length between 3 and 30 characters');
      }
    }

    create() {
      return POST("v2.projects", {
        method: "POST",
        path: `/sequence/${enc(this.id())}`
      }, void 0);
    }

    save() {
      return this.create();
    }

    static delete(sequenceId) {
      return POST("v2.projects", {
        method: "DELETE",
        path: `/sequence/${enc(sequenceId)}`
      }, void 0);
    }

    destroy(sequenceId) {
      return WeaverSequence.delete(sequenceId);
    }

    static next(sequenceId) {
      return POST("v2.projects", {
        method: "POST",
        path: `/sequence/${enc(sequenceId)}/next`
      }, void 0);
    }

    static list() {
      return POST("v2.projects", {
        method: "GET",
        path: "/sequence"
      }, void 0);
    }

  };

  module.exports = WeaverSequence;

}).call(this);
